export const educationData = [
    {
        id: 1,
        institution: 'full stack Academy ',
        course: 'MERN Full Stack Development',
        startYear: 'sep 2021',
        endYear: 'march 2022'
    },
   
    {
        id: 2,
        institution: 'Pune University',
        course: 'Bachelors in Computer Application (BCA).',
        startYear: '2018',
        endYear: '2021'
    },
    {
        id: 3,
        institution: 'The Poona College of Arts, Science and Commerce',
        course: 'Intermediate',
        startYear: '2016',
        endYear: '2018'
    },
    
]